<template>
  <div
    class="
      col-span-full
      grid grid-cols-1
      gap-x-4 gap-y-8
      md:grid-cols-2
      lg:grid-cols-3
      pb-4
      mt-8
    "
  >
    <Content
      class="col-span-full"
      v-if="isRealVisible"
      title="REALTIME_REPORT"
      :showBreadcrumb="false"
      :showAdd="false"
    >
      <ChooseCar :hardware="imei" />
      <RealTime />
    </Content>

    <!-- <TodayStats /> -->
  </div>
</template>

<script>
import Summary from '@/pages/home/summary'
import RealTime from '@/pages/home/realtime'
import ChooseCar from '@/pages/home/ChooseCar'
import Service from '@/pages/home/service'
import LicensePlate from '@/components/cars/LicensePlate'
import { licenseChars } from '@/api/global'

import {
  fleetTodays,
  driversStats,
  vehiclesOwnershipStats,
  vehiclesStats,
} from '@/api/dashboard'

export default {
  data() {
    return {
      isRealVisible: true,
      drivers_stat: {
        status_stat: [],
      },
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],
      driverLoading: true,
      vehicleLoading: true,
      vehicle_stat: {
        driver_status_stats: [],
        vehicle_ownership_stats: [],
        vehicle_status_stats: [],
      },
      driverStats: [],
      ownershipStats: [],
      realtimeChart: [],
      vehicleStats: [],
      imei: [],

      res: null,
      fleetStat: null,
      todayReport: null,
      showRealtime: false,
    }
  },
  components: {
    Summary,
    RealTime,
    ChooseCar,
    Service,
    LicensePlate,
    // TodayStats
  },
  methods: {
    async liveLocation() {
      const res = await this.$store.dispatch('liveTracking', {
        selectedVehicle: '',
        selectedTags: '',
        selectedStatus: '',
      })
      if (res) {
        this.showRealtime = true
        this.realtimeChart = [
          {
            id: 1,
            color: {
              id: 1,
              en_title: 'green',
              fa_title: 'سبز',
              code: '#67C23A',
            },
            count: res.filter(
              (item) => item.properties.traffic_status !== 'offline'
            ).length,
            en_title: this.$t('updated_vechiles'),
            fa_title: this.$t('updated_vechiles'),
          },
          {
            id: 2,
            color: {
              id: 2,
              en_title: 'gray',
              fa_title: 'طوسی',
              code: '#f59e0b',
            },
            count: res.filter(
              (item) => item.properties.traffic_status === 'offline'
            ).length,
            en_title: this.$t('updated_not_vechiles'),
            fa_title: this.$t('updated_not_vechiles'),
          },
        ]
      }
    },
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res
    })

    // fleetTodays.api().then((res) => {
    //   if (res) {
    //     this.todayReport = res
    //   }
    // })

    // driversStats.api().then((res) => {
    //   if (res) {
    //     this.driverStats = res
    //   }
    // })

    // vehiclesOwnershipStats.api().then((res) => {
    //   if (res) {
    //     this.ownershipStats = res
    //   }
    // })
    // vehiclesStats.api().then((res) => {
    //   if (res) {
    //     this.vehicleStats = res
    //   }
    // })
    this.liveLocation()
  },
}
</script>
